import React from 'react';
import { LabelStyled, SwitcherItemStyled } from './styled';
export function SwitcherItem({ id, name, value, label, isChecked, isDisabled, onChange, isRightToLeft = false, }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(SwitcherItemStyled, { id: id, name: name, value: value, checked: isChecked, disabled: isDisabled, type: "radio", onChange: onChange }),
        React.createElement(LabelStyled, { isRightToLeft: isRightToLeft, htmlFor: id }, label)));
}
